export default __webpack_public_path__ + "a27eb7b6c2f252932a2892a3cf991d5c.png";